import React, { Component } from "react";

import CustomSelect from "../../../../common/CustomSelect";
import {
  IconCalendar,
} from "../../../../common/icons";

const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];
class TabTrucks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadTabActive: false,
      showUploadModal: false,
    };
  }
  handleShowUploadModal = (event) => {
    this.setState({ showUploadModal: true });
  };
  handleHideUploadModal = (event) => {
    this.setState({ showUploadModal: false });
  };
  handleLoadTabActive = (i) => {
    this.setState({
      isLoadTabActive: this.state.isLoadTabActive === i ? null : i,
    });
  };
  render() {
    return (
      <div className="tab" id="tab-chassis">
        <div className="card">
          <div className="pt-30 px-20 mb-10">
            <div className="row">
              <div className="form-group col-lg-4">
                <label>Fleet Owner</label>
                <CustomSelect
                  name={"name"}
                  options={options}
                  value={1}
                  isMulti={true}
                  isClearable={true}
                  size="small"
                  placement="right"
                  placeholder="Select Owner"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>Year</label>
                <CustomSelect
                  name={"name"}
                  options={options}
                  value={1}
                  isMulti={true}
                  isClearable={true}
                  size="small"
                  placement="right"
                  placeholder="Select Year"
                  className="w-150"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>Hut Expiration</label>
                <div className="input-wrapper w-150">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Date"
                  />
                  <span className="input-icon">
                    <IconCalendar />
                  </span>
                </div>
              </div>
              <div className="form-group col-lg-4">
                <label>Equipment ID</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Equipment ID"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>Lisence Plate #</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Enter Lisence Plate #"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>Diesel Emission</label>
                <CustomSelect
                  name={"name"}
                  options={options}
                  value={1}
                  isMulti={true}
                  isClearable={true}
                  size="small"
                  placement="right"
                  placeholder="Select Port"
                  className="w-150"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>AID</label>
                <input
                  type="text"
                  className="form-control w-150"
                  placeholder="Enter AID"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>ITD</label>
                <input
                  type="text"
                  className="form-control w-150"
                  placeholder="Enter AID"
                />
              </div>
              <div className="form-group col-lg-4">
                <label>VIN</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter VIN"
                />
              </div>

              <div className="form-group col-lg-4">
                <label>Registration Exp</label>
                <div className="input-wrapper">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Date"
                  />
                  <span className="input-icon">
                    <IconCalendar />
                  </span>
                </div>
              </div>
              <div className="form-group col-lg-4">
                <label>Inspection Exp</label>
                <div className="input-wrapper">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Date"
                  />
                  <span className="input-icon">
                    <IconCalendar />
                  </span>
                </div>
              </div>
              <div className="form-group col-lg-4">
                <label>RFID #</label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter RFID #"
                />
              </div>
            </div>

            <div className="row">
              <div className="form-group col-lg-4">
                <label>Annual Inspection</label>
                <div className="input-wrapper w-150">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Date"
                  />
                  <span className="input-icon">
                    <IconCalendar />
                  </span>
                </div>
              </div>
              <div className="form-group col-lg-4">
                <label>Bobtail Insurance</label>
                <div className="input-wrapper w-150">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Date"
                  />
                  <span className="input-icon">
                    <IconCalendar />
                  </span>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="form-group col-lg-4">
                <label>IFTA</label>
                <div className="input-wrapper w-150">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Select Date"
                  />
                  <span className="input-icon">
                    <IconCalendar />
                  </span>
                </div>
              </div>
              <div className="form-group col-lg-4">
                <label>GPS</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter GPS"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Date monthly maintenance last received</label>
              <div className="input-wrapper w-150">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Select Date"
                />
                <span className="input-icon">
                  <IconCalendar />
                </span>
              </div>
            </div>
            <div className="form-group">
              <label>Date monthly maintenance next due</label>
              <div className="input-wrapper w-150">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Select Date"
                />
                <span className="input-icon">
                  <IconCalendar />
                </span>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button className="btn btn-link">Cancle</button>
            <button className="btn btn-primary">Save Changes</button>
          </div>
        </div>
      </div>
    );
  }
}

export default TabTrucks;
